import { FC } from 'react';

import { useTranslation } from '@/shared/utils/i18n/useTranslation';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { EditScenarioConfirmationModalProps } from '@/widgets/modals/types';

import { ScenarioConfirmationModal } from '../ScenarioActionConfirmationModalContainer';

export const EditScenarioConfirmationModal: FC<EditScenarioConfirmationModalProps> = ({
  onConfirm,
}) => {
  const { closeModal } = useModalsStore();

  const { t } = useTranslation('widgets/scenariosActions', {
    keyPrefix: 'editScenarioConfirmationModal',
  });

  const onSubmit = () => {
    onConfirm();
    closeModal();
  };

  return (
    <ScenarioConfirmationModal
      cancelButtonText={t('cancelButton')}
      content={t('content')}
      onClose={closeModal}
      onSubmit={onSubmit}
      submitButtonText={t('submitButton')}
      title={t('title')}
    />
  );
};
